export enum TypeofEnum {
  UNDEFINED = 'undefined',
  OBJECT = 'object',
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  BIGINT = 'bigint',
  STRING = 'string',
  SYMBOL = 'symbol',
  FUNCTION = 'function'
}
